import { HttpContextToken, HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';

export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const messages = inject(MessageService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (req.context.get(SKIP_ERROR_TOAST)) {
        return throwError(() => error);
      }

      const detail = error.error?.message ?? 'Ha ocurrido un error inesperado';

      const summaryMap: Record<number, string> = {
        400: 'Solicitud inválida',
        403: 'Sin permisos',
        404: 'No encontrado',
        500: 'Error del servidor',
      };

      const isLoginRequest = req.url.includes('/auth/login');
      const shouldShowToast = error.status !== 401 || isLoginRequest;

      if (shouldShowToast) {
        messages.add({
          severity: error.status === 400 || error.status === 404 ? 'warn' : 'error',
          summary: summaryMap[error.status] ?? 'Error',
          detail: error.status === 403 ? 'No tienes acceso a este recurso' : detail,
        });
      }

      return throwError(() => error);
    }),
  );
};
